import styled from "styled-components";
import { creditHeaderSize } from "../../../PagesUser/SelfServiceCampaignCreation/campaign-creation/booking-overview/BookingOverview.styled";

export const AddExtra = styled.div`
  line-height: 17px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  color: #4056f4;
  transition: color 0.2s;

  &:hover {
    color: #1e22ff;
  }

  span {
    display: flex;
    align-items: center;
    padding: 1px;
    border: 1px solid #1e22ff;
    border-radius: 50%;
  }

  p {
    ${creditHeaderSize};
    font-family: Rubik;
    font-style: normal;
    font-weight: 400;
  }

  svg {
    color: #1e22ff;
  }
`;
